(function () {
  const playVideo = (video) => {};

  const stopVideo = (video) => {};

  const initSection = (section) => {
    let sectionVideo = document.currentScript
      ? document.currentScript.parentElement
      : section;

    let lazyVideos = [...document.querySelectorAll("video.video--lazyLoad")];

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((video) => {
        if (video.isIntersecting) {
          for (let source in video.target.children) {
            let videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }
          video.target.load();
          video.target.classList.remove("video--lazyLoad");
          sectionObserver.unobserve(video.target);
        }
      });
    });
    lazyVideos.forEach(function (lazyVideo) {
      sectionObserver.observe(lazyVideo);
    });
  };
  const initVideoThumbs = (section) => {
    const videos = document.querySelectorAll("[video-thumb]");

    videos.forEach((video) => {
      video.removeAttribute("controls");
      video.muted = true; // Ensure the video stays muted
      video.addEventListener("mouseenter", () => {
        video.play();
        video.muted = false;
      });

      video.addEventListener("mouseleave", () => {
        video.pause();
        video.muted = true; // Ensure the video stays muted
      });

      video.addEventListener("click", () => {
        // Optional: Let the user toggle play/pause with a click
        if (video.paused) {
          video.play();
          video.muted = false;
        } else {
          video.pause();
          video.muted = true;
        }
      });
    });
  };

  initSection();
  initVideoThumbs();
  document.addEventListener("shopify:section:load", function (section) {
    initSection(section.target);
  });
})();
